import React, { useContext, useEffect, useMemo, useState } from "react";
import { AppContext, ValueContext } from "../../../context/createContext";
import { Coeficient, Title, TextInfoWrapper } from "../GameBoardStyle";
import ProgressBar from "../progressBar/ProgressBar";
import { useTranslation } from "../../../locale/context";

export default function TextInfo() {
  const { jackpot } = useContext(AppContext);
  const { roundupdate } = useContext(ValueContext);
  const { value, state } = roundupdate;
  const [text, setText] = useState<string>("first step");

  const { t } = useTranslation();
  const languagePack = useMemo(() => {
    return {
      nextRound: t("common.gameState.nextRound"),
      disasterTitle: t("common.gameState.disasterTitle"),
      disaster: t("common.gameState.disaster"),
      jackpotTitle: t("common.gameState.jackpotTitle"),
      jackpot: t("common.gameState.jackpot"),
      state1: t("common.gameState.state1"),
      state2: t("common.gameState.state2"),
      state3: t("common.gameState.state3"),
      state4: t("common.gameState.state4"),
      state5: t("common.gameState.state5"),
    };
  }, [t]);

  const spaceText = [
    { startValue: 0, endValue: 2, text: languagePack.state1 },
    { startValue: 2, endValue: 4, text: languagePack.state2 },
    { startValue: 4, endValue: 6, text: languagePack.state3 },
    { startValue: 6, endValue: 5000, text: languagePack.state4 },
    // { startValue: 400, endValue: 1000, text: "ICE GIANT" },
    // { startValue: 1000, endValue: 4200, text: "BIG BLUE" },
  ];

  useEffect(() => {
    spaceText.map((val) => {
      if (Number(value) >= val.startValue && Number(value) < val.endValue) {
        setText(val.text);
      } else if (Number(value) >= 4200) {
        setText(languagePack.state5);
      }
    });
  }, [value]);

  return (
    <TextInfoWrapper className="textInfo">
      {jackpot.status === "start" ? (
        <div className={"jackpot"}>
          <Title className={"jackpot-title"}>{languagePack.jackpotTitle}</Title>
          <Coeficient className={"jackpot-text"}>
            {languagePack.jackpot}
          </Coeficient>
        </div>
      ) : state === 2 ? (
        <div>
          <Title>{text}</Title>
          <Coeficient>{value}x</Coeficient>
        </div>
      ) : state === 3 ? (
        <div>
          <Title>{languagePack.disasterTitle}</Title>
          <Coeficient>{languagePack.disaster}</Coeficient>
        </div>
      ) : state === 1 ? (
        <ProgressBar state={state} />
      ) : null}
    </TextInfoWrapper>
  );
}
